import { ICategory } from '@shared/models/category';
import { Product } from '@shared/models/product';

/** System-Warengruppe laut Seed/Migration (bcm_product_categories.id = 1). */
export const BERTH_FEE_PRODUCT_CATEGORY_ID = 1;

/** Legacy-Fallback, falls uniqueId in der DB noch korrekt ist. */
export const BERTH_FEE_PRODUCT_CATEGORY_UNIQUE_ID = 'Liegeplatzgebühr';

export function isBerthFeeProductCategory(category: ICategory | null | undefined): boolean {
    if (!category) {
        return false;
    }

    if (category.id === BERTH_FEE_PRODUCT_CATEGORY_ID) {
        return true;
    }

    if (
        category.uniqueId === BERTH_FEE_PRODUCT_CATEGORY_UNIQUE_ID
        || category.name === BERTH_FEE_PRODUCT_CATEGORY_UNIQUE_ID
    ) {
        return true;
    }

    return isBerthFeeProductCategory(category.parentCategory);
}

export function isBerthFeeProduct(product: Product | null | undefined): boolean {
    return isBerthFeeProductCategory(product?.category);
}

export function filterBerthFeeProducts(products: Product[]): Product[] {
    return (products || []).filter(isBerthFeeProduct);
}

export function excludeBerthFeeProducts(products: Product[]): Product[] {
    return (products || []).filter(product => !isBerthFeeProduct(product));
}
